"use client";

import { usePathname } from "@/i18n/routing";
import styles from "./Footer.module.css";

export const FooterWrapper = ({ children }: { children: React.ReactNode }) => {
	const pathname = usePathname();

	const isCheckout = pathname.includes("checkout") && !pathname.includes("summary");

	if (isCheckout) return null;

	return <div className={styles.root}>{children}</div>;
};
